export default __webpack_public_path__ + "static/media/customer.32bae4e2.svg";